import React from 'react'
import { Button } from 'reactstrap';
import { FormIndications } from './FormIndications';
import { Dialog } from 'primereact/dialog';

export const ModalIndications = (props) => {

    const {

        method, modalTitle, loading, modal, closeDialog,
        saveCreate,handleInputChange,saveUpdate,saveDelete,
        id_exam_indication, indication,validaciones
        

    }= props;

    const footer = (
        <>
        <hr />
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>

            <Button
                color="primary"
                size="sm"
                disabled={loading}
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "progress-bar-animated progress-bar-striped" : ""}
            >
                {
                    loading
                        ? (
                            <>
                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                {
                                    method === "create"
                                        ? "Guardando..."
                                        : "Actualizando..."
                                }
                            </>
                        )
                        : (
                            method === "create"
                                ? "Guardar"
                                : "Actualizar"
                        )
                }
            </Button>
        </>
    );


    return (        
        <Dialog 
            header={modalTitle}
            visible={modal} 
            onHide={closeDialog} 
            closable 
            modal 
            blockScroll 
            className='medium-dialog'
            maskClassName="medium-dialog-mask"
            footer={footer}
        >
            {
                method === "create"
                ? <FormIndications
                    {...{ loading, handleInputChange,validaciones,methodAction: saveCreate}}
                />
                : (method === "update")

                    ?
                    <FormIndications
                        {...{
                            loading, handleInputChange,id_exam_indication, indication,validaciones,  methodAction: saveUpdate,
                        }}
                    />
                    : null
            }
        </Dialog>
       
    )
}
